import React, { useState } from "react";
import ReactDOM from "react-dom";
import { FiX, FiExternalLink, FiDownload, FiChevronLeft, FiChevronRight, FiMaximize2 } from "react-icons/fi";

function DesignModal({ isOpen, onClose, design }) {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  if (!isOpen || !design) return null;

  const images = design.images || [design.image];
  const currentImage = images[currentImageIndex];
  const fullDesignImage = design.fullDesign || design.image; // Use fullDesign if available, fallback to main image

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  const modalContent = (
    <div className="modal-overlay portfolio-modal" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          <FiX />
        </button>
        
        <div className="modal-header">
          <h3 className="modal-title">{design.title}</h3>
          <p className="modal-subtitle">{design.tech}</p>
        </div>
        
                <div className="modal-image-container">
                  {images.length > 1 && (
                    <button className="modal-nav modal-nav--prev" onClick={prevImage}>
                      <FiChevronLeft />
                    </button>
                  )}

                  <img
                    src={currentImage}
                    alt={`${design.title} - ${currentImageIndex + 1}`}
                    className="modal-image"
                  />

                  {images.length > 1 && (
                    <button className="modal-nav modal-nav--next" onClick={nextImage}>
                      <FiChevronRight />
                    </button>
                  )}
                </div>
        
                {images.length > 1 && (
                  <div className="modal-image-counter">
                    {currentImageIndex + 1} / {images.length}
                  </div>
                )}
        
        <div className="modal-description">
          <p>Dit is een design concept dat ik heb gemaakt. Het toont mijn visie voor {design.title.toLowerCase()} en demonstreert mijn ontwerpvaardigheden.</p>
        </div>
        
                <div className="modal-actions">
                  <button 
                    className="btn btn--primary" 
                    onClick={() => window.open(fullDesignImage, '_blank')}
                  >
                    <FiMaximize2 />
                    <span>Bekijk Volledig</span>
                  </button>
                  <button 
                    className="btn btn--secondary" 
                    onClick={() => window.open(currentImage, '_blank')}
                  >
                    <FiExternalLink />
                    <span>Open in Nieuw Tab</span>
                  </button>
                  <a 
                    href={currentImage} 
                    download 
                    className="btn btn--secondary"
                  >
                    <FiDownload />
                    <span>Download</span>
                  </a>
                </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
}

export default DesignModal;
